import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Tooltip } from '@dixa/lib-shared-habla';
import { formatInternational, getCountryCodeFromPhoneNumber, getPhoneNumberCountryCodeFormatted, } from 'lib-shared-phone-numbers';
import _filter from 'lodash/filter';
import { PureComponent } from 'react';
import Collapsible from 'react-collapsible';
import ListNumbers from './ListNumbers';
import PhoneNumbersCustomInput from './PhoneNumbersCustomInput';
import '../styles/from-number-selector.less';
export default class CustomDropDownButton extends PureComponent {
    constructor(props) {
        super(props);
        this.fromNumberFormat = (fromNumberFormat) => {
            this.props.returnFromNumberFormat(fromNumberFormat);
        };
        this.findNumberByCountryCode = (number = null) => {
            let verifiedNumbers = null;
            if (this.props.staticTelephoneNumbersArray.length === 0) {
                console.warn('_findSameOwnNumberWithSameCountryCode no owned number given.');
                return null;
            }
            if (this.props.agentDefaultNumber) {
                verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
                    e164_format: this.props.agentDefaultNumber,
                });
            }
            else {
                verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
                    default: true,
                });
            }
            if (!verifiedNumbers || verifiedNumbers.length === 0) {
                verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray);
            }
            let foundNumber = null;
            if (number !== null) {
                // find country code on number and match it with a from number (if any).
                const countryCode = getPhoneNumberCountryCodeFormatted(number);
                for (const ownedNumber of verifiedNumbers) {
                    const ownedCountryCode = getPhoneNumberCountryCodeFormatted(ownedNumber.e164_format);
                    if (countryCode === ownedCountryCode) {
                        // Found own number with same countryCode as user.
                        foundNumber = ownedNumber;
                        break;
                    }
                } // end loop.
            }
            return foundNumber;
        };
        this.onOwnNumberToggle = () => {
            if (this.props.isOwnNumbersViewOpen) {
                this.props.toggleOwnNumbersView(false);
            }
            else {
                this.props.toggleOwnNumbersView(true);
            }
        };
        this.changeFromNumber = (fromNumber = null) => {
            var _a;
            if (fromNumber === null) {
                return;
            }
            this.props.changeFromNumber({ number: fromNumber });
            const fromPhoneNumberFormat = formatInternational(fromNumber.e164_format) || fromNumber.e164_format;
            const fromNumberRegion = ((_a = getCountryCodeFromPhoneNumber(fromNumber.e164_format)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ||
                'Unknown';
            const fromNumberCountryCode = getPhoneNumberCountryCodeFormatted(fromNumber.e164_format) || null;
            this.props.setFromNumberCountryCode(fromNumberCountryCode);
            this.props.returnFromNumberFormat(fromPhoneNumberFormat);
            this.setState({ fromNumberRegion, fromNumberCountryCode });
        };
        this.state = {
            fromNumberRegion: 'Unknown',
        };
    }
    UNSAFE_componentWillMount() {
        this.props.telephonyGetAllOwnNumbers();
        this.props.telephonyGetDefaultNumber();
    }
    componentDidUpdate(prevProps) {
        let verifiedNumbers = null;
        if (this.props.agentDefaultNumber) {
            verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
                e164_format: this.props.agentDefaultNumber,
            });
        }
        else {
            verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
                default: true,
            });
        }
        if (!verifiedNumbers || verifiedNumbers.length === 0) {
            verifiedNumbers = _filter(this.props.staticTelephoneNumbersArray, {
                outgoing_functionality: true,
            });
        }
        if (this.props.selectedFromNumber === null && verifiedNumbers.length > 0) {
            let outboundNumber = '';
            if (this.props.fromNumberFormat) {
                outboundNumber = this.props.fromNumberFormat;
            }
            else {
                outboundNumber = '+4560860931';
            }
            const fromNumber = this.findNumberByCountryCode(outboundNumber); // @TODO make a default counrty for each organization.
            if (fromNumber !== null) {
                this.changeFromNumber(fromNumber);
            }
            else {
                this.changeFromNumber(verifiedNumbers[0]);
            }
        }
        if (prevProps.selectedFromNumber !== this.props.selectedFromNumber) {
            this.changeFromNumber(this.props.selectedFromNumber);
        }
    }
    render() {
        let fromNumber = null;
        let disabledPrevious = '';
        let disabledNext = '';
        let previousLink;
        let nextLink;
        let isHidden = '';
        let buttonsHidden = '';
        if (this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length > 0 &&
            this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.dynamicTelephoneNumbersArray.length === 0) {
            buttonsHidden = ' hidden';
        }
        if (this.props.selectedFromNumber && this.props.selectedFromNumber.name) {
            fromNumber = (_jsxs("div", Object.assign({ className: "call-from flags" }, { children: [_jsx("p", Object.assign({ className: "m-b-5 noselect" }, { children: "Outbound number" })), _jsx(Tooltip, Object.assign({ placement: "top", content: "Outbound call recording is active", dark: true }, { children: _jsx("span", Object.assign({ className: 'call-recording ' +
                                (this.props.selectedFromNumber.record_outbound_calls === true
                                    ? ''
                                    : 'hidden') }, { children: _jsx(DixaIcon, { icon: "rec" }) })) })), _jsx("span", { className: 'flag ' + this.state.fromNumberRegion.toLowerCase() }), _jsx(Tooltip, Object.assign({ placement: "bottom", content: this.props.selectedFromNumber.name, dark: true }, { children: _jsxs("span", Object.assign({ className: "from-number-name" }, { children: [this.props.fromNumberFormat, ' ', _jsxs("em", { children: ["(", this.props.selectedFromNumber.name, ")"] })] })) })), _jsx(DixaIcon, { icon: "angle-right" })] })));
        }
        else if (this.props.selectedFromNumber) {
            fromNumber = (_jsxs("div", Object.assign({ className: "call-from flags" }, { children: [_jsx("p", Object.assign({ className: "m-b-5 noselect" }, { children: "Outbound number" })), _jsx(Tooltip, Object.assign({ placement: "top", content: "Outbound call recording is active", dark: true }, { children: _jsx("span", { className: 'call-recording ' +
                                (this.props.selectedFromNumber.record_outbound_calls === true
                                    ? ''
                                    : 'hidden') }) })), _jsx("span", { className: 'flag ' + this.state.fromNumberRegion.toLowerCase() }), _jsx("span", { children: this.props.fromNumberFormat }), _jsx(DixaIcon, { icon: "angle-right" })] })));
        }
        if (this.props.previousPage === null) {
            disabledPrevious = 'disabled';
            previousLink = (_jsxs("a", Object.assign({ type: "button" }, { children: [_jsx("span", Object.assign({ style: { verticalAlign: '-2px' } }, { children: _jsx(DixaIcon, { icon: "arrow-left" }) })), "Prev Page"] })));
        }
        else {
            previousLink = (_jsxs("a", Object.assign({ type: "button", style: { cursor: 'pointer' }, onClick: () => this.props.telephonyGetQueryNumbers({
                    query: { path: this.props.previousPage, limit: '15' },
                }) }, { children: [_jsx("span", Object.assign({ style: { verticalAlign: '-2px' } }, { children: _jsx(DixaIcon, { icon: "arrow-left" }) })), "Prev Page"] })));
        }
        if (this.props.nextPage === null) {
            disabledNext = 'disabled';
            nextLink = (_jsxs("a", Object.assign({ className: buttonsHidden, type: "button" }, { children: ["Next page", _jsx("span", Object.assign({ style: { verticalAlign: '-2px' } }, { children: _jsx(DixaIcon, { icon: "arrow-right" }) }))] })));
        }
        else {
            nextLink = (_jsxs("a", Object.assign({ className: buttonsHidden, type: "button", style: { cursor: 'pointer' }, onClick: () => this.props.telephonyGetQueryNumbers({
                    query: { path: this.props.nextPage, limit: '15' },
                }) }, { children: ["Next page", _jsx("span", Object.assign({ style: { verticalAlign: '-2px' } }, { children: _jsx(DixaIcon, { icon: "arrow-right" }) }))] })));
        }
        if (this.props.meta.staticTelephoneNumbersArrayAsyncStatus === 'succeeded' &&
            this.props.staticTelephoneNumbersArray.length === 0) {
            isHidden = ' hidden';
        }
        return (_jsxs("div", Object.assign({ className: `collapsible-holder from-numbers-selector${isHidden}` }, { children: [_jsxs(Collapsible, Object.assign({ handleTriggerClick: this.onOwnNumberToggle, open: this.props.isOwnNumbersViewOpen, trigger: fromNumber, transitionTime: 300, easing: "ease" }, { children: [_jsx("li", Object.assign({ className: "own-number-change dropdown-header", role: "heading" }, { children: "Search outbound numbers" })), _jsx(PhoneNumbersCustomInput, { telephonyGetQueryNumbers: this.props.telephonyGetQueryNumbers }), _jsx("li", Object.assign({ className: `own-number-change${buttonsHidden} dropdown-header`, role: "presentation" }, { children: "Select outbound number" })), _jsx(ListNumbers, { dynamicTelephoneNumbersArray: this.props.dynamicTelephoneNumbersArray, onToggle: this.onOwnNumberToggle, selectedFromNumber: this.props.selectedFromNumber, changeFromNumber: this.changeFromNumber }), (this.props.meta.dynamicTelephoneNumbersArrayAsyncStatus ===
                            'loading' && (_jsxs("ul", Object.assign({ className: `pager${buttonsHidden}`, style: { margin: 'auto' } }, { children: [_jsx("li", Object.assign({ className: "disabled pull-left" }, { children: _jsxs("a", Object.assign({ type: "button" }, { children: [' ', _jsx("span", Object.assign({ style: { verticalAlign: '-2px' } }, { children: _jsx(DixaIcon, { icon: "arrow-left" }) })), "Loading", ' '] })) })), _jsx("li", Object.assign({ className: "disabled pull-right" }, { children: _jsxs("a", Object.assign({ type: "button" }, { children: [' ', "Loading", ' ', _jsxs("span", Object.assign({ style: { verticalAlign: '-2px' } }, { children: [' ', _jsx(DixaIcon, { icon: "arrow-right" }), ' '] }))] })) }))] })))) || (_jsxs("ul", Object.assign({ className: `pager${buttonsHidden}`, style: { margin: 'auto' } }, { children: [_jsx("li", Object.assign({ className: disabledPrevious + ' previous' }, { children: previousLink })), _jsx("li", Object.assign({ className: disabledNext + ' next' }, { children: nextLink }))] })))] })), _jsx("li", { className: "divider", role: "separator", style: { margin: '13px 0 0 0', width: '100%' } })] })));
    }
}
